import axios from 'axios';

// Production backend URL - fixed to avoid Cloudflare env var issues
const PRODUCTION_BACKEND = 'https://legal-report-gen.emergent.host';
const API_URL = PRODUCTION_BACKEND;

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Health check
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

// Create preview
export const createPreview = async (wizardData) => {
  const response = await api.post('/preview', {
    wizard_data: wizardData
  });
  return response.data;
};

// Create checkout session
export const createCheckout = async (caseId, originUrl, plan = 'basic') => {
  const response = await api.post('/checkout', {
    case_id: caseId,
    origin_url: originUrl,
    plan: plan
  });
  return response.data;
};

// Get checkout status
export const getCheckoutStatus = async (sessionId) => {
  const response = await api.get(`/checkout/status/${sessionId}`);
  return response.data;
};

// Get report
export const getReport = async (caseId) => {
  const response = await api.get(`/r/${caseId}`);
  return response.data;
};

// Get services catalog
export const getServices = async () => {
  const response = await api.get('/services');
  return response.data;
};

// Admin API
export const adminApi = {
  login: async (username, password) => {
    const response = await api.post('/admin/login', { username, password });
    return response.data;
  },
  
  getCases: async (token, params = {}) => {
    const response = await api.get('/admin/cases', {
      headers: { Authorization: `Bearer ${token}` },
      params
    });
    return response.data;
  },
  
  getCase: async (token, caseId) => {
    const response = await api.get(`/admin/cases/${caseId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  resendEmail: async (token, caseId) => {
    const response = await api.post(`/admin/cases/${caseId}/resend-email`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  getStats: async (token) => {
    const response = await api.get('/admin/stats', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  getServices: async (token) => {
    const response = await api.get('/admin/services', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  saveService: async (token, service) => {
    const response = await api.post('/admin/services', service, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },
  
  deleteService: async (token, code) => {
    const response = await api.delete(`/admin/services/${code}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};

export default api;
